const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS4yOTI5IDguMjkyOTFMMjAuNzA3MSA5LjcwNzEyTDEyIDE4LjQxNDJMMy4yOTI4OSA5LjcwNzEyTDQuNzA3MTEgOC4yOTI5MUwxMiAxNS41ODU4TDE5LjI5MjkgOC4yOTI5MVoiLz4KPC9zdmc+Cg==";
export {
  I as default
};
//# sourceMappingURL=arrow_down-0fa28b72.mjs.map
